import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
  Container,
} from 'reactstrap'
import styled from 'styled-components'

export const CancelCompensateWorkForm = (props) => {
  const { open } = props
  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal
        isOpen={ open }
        toggle={ () => props.toggle() }
      >
        <HeaderForm toggle={ () => props.toggle() }>
          <HeadLabel>Cancel Compensate Work</HeadLabel>
        </HeaderForm>
        <ModalBody>
          <Container>
            <TextLabel>Are you sure you want to cancel this request?</TextLabel>
            <br />
            <TextLabel >Remarks (Optional)</TextLabel>
            <TextArea
              name="submit_remark"
              onBlur={ (e) => props.handleCancelRemark(e) }
            />
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button onClick={ () => props.toggle() }>
            No
          </Button>
          <Button
            color='danger'
            onClick={ () => props.cancelCompensateReport() }
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

CancelCompensateWorkForm.propTypes = {
  cancelCompensateReport: PropTypes.func,
  handleCancelRemark: PropTypes.func,
  toggle: PropTypes.func,
  open: PropTypes.bool,
}
CancelCompensateWorkForm.defaultProps = {
  cancelCompensateReport: () => {},
  handleCancelRemark: () => {},
  toggle: () => {},
  open: false,
}

const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`
const TextLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const TextArea = styled.textarea`
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/report/form/cancel-compensate-work.js